import { IDemoAttributionParams } from '@aqx-core/common/api/account';
import { EPasswordType } from '@aqx-core/common/api/account-link';
import { ELoginSource } from '@aqx-core/common/api/auth';
import { TAppLanguageISOCountryCode } from '@aqx-core/common/i18n';

import { ELoginConfigType, EMainProductCodeType } from '../../config';

export enum EBaseCurrency {
  USD = 'USD',
  EUR = 'EUR',
  THB = 'THB'
}

export const CurrencySymbol: Record<EBaseCurrency, string> = {
  [EBaseCurrency.USD]: '$',
  [EBaseCurrency.EUR]: '€',
  [EBaseCurrency.THB]: '฿'
};

export enum EAccountType {
  LIVE = 'LIVE',
  DEMO = 'DEMO'
}

export enum EAccountDisplayType {
  MASTER = 'MASTER',
  LIVE = 'LIVE',
  VIRTUAL = 'VIRTUAL',
  DEMO = 'DEMO'
}

export enum ESimple2TradeAccountType {
  DEMO = 'DEMO',
  LIVE = 'LIVE',
  COPY_F = 'COPY_F',
  COPY_M = 'COPY_M',
  MAM = 'MAM',
  PAMM = 'PAMM',
  INV = 'INV'
}

export enum ETradingState {
  NEUTRAL = 'NEUTRAL',
  MARGIN_CALL = 'MARGIN_CALL',
  STOPPED_OUT = 'STOPPED_OUT'
}

export enum ECrmType {
  SIMPLE2TRADE = 'SIMPLE2TRADE',
  STONEINNO = 'STONEINNO',
  FXCRM = 'FXCRM',
  TRADAWISE = 'TRADEWISE'
}

export interface ISwitchMetatraderAccountParams {
  metatraderId: number;
  passwordType?: EPasswordType;
  serverId?: number;
}

export interface IDemoAccountCreationV1Params {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
  name?: string;
}

export interface ILogoutDevicesParams {
  sources?: ELoginSource;
  loginTime: string[];
}

export interface IUserDetail {
  tradingAccounts: ITradingAccount[];
  crmType: ECrmType;
  loginConfig: ELoginConfigType;
  notificationTopics: string[];
}

export interface ITradingAccount {
  accountId: string;
  userId: string;
  clientId: string;
  userGroup: string;
  accountName?: string;
  accountNumber: number;
  baseCurrency: EBaseCurrency;
  isDemo: boolean;
  platform: string;
  isVirtual: boolean;
  realizedPL: number;
  unRealizedPL: number;
  strategy: string;
  balance: number;
  margin: number;
  equity: number;
  profitLoss: number;
  freeMargin: number;
  marginLevel: number;
  traderId: string;
  traderSubscription: string;
  marketSubcription: string;
  metatraderId: number;
  accountType: EAccountType;
  accountDisplayType: EAccountDisplayType;
  accountTypeName: string;
  simple2TradeAccountType: ESimple2TradeAccountType;
  canSwitch: boolean;
  leverage: number;
  readOnly: number;
  lastVerifiedDate: number;
  language: TAppLanguageISOCountryCode | null;
  marginCall: number;
  marginStopout: number;
  pnlGross: number;
  buyingPower: number;
  sellingPower: number;
  notional: number;
  commission: number;
  swaps: number;
  availableWithdraw: number;
  credit: number;
  tradingState: ETradingState;
  serverId: number;
  mainProductCode: EMainProductCodeType;
  omsServerId: string;
  selected: boolean;
  enable: boolean;
  dealer: string;
}

export interface ISwitchMetatraderAccount {
  virtualAccountId: number;
  strategy: string;
  balance: number;
  realizedProfitLost: number;
  unrealizedProfitLost: number;
  currency: string;
  platform: string;
  metatraderGroup: string;
  metatraderId: number;
  traderSubcription: string;
  marketSubcription: string;
  switchedAccountToken: string;
  virtual: boolean;
  demo: boolean;
}

export interface IActiveSessionDevice {
  loginSource: ELoginSource;
  lastActivity: number;
  ipAddress: string;
  deviceType: string;
  browserType: string;
  loginTime: string;
  active: boolean;
}

export interface IDemoSignUpParams {
  depositAmount: number;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  country: string;
  loginSource?: ELoginSource;
  appsFlyerAttribute?: IDemoAttributionParams;
  marketingPageUrl?: string;
  language?: string;
}

export interface IDemoAccountCreation {
  login: string;
  name: string;
  email: string;
  investorPassword: string;
  password: string;
  userGroup: string;
  deposit: number;
  leverage: number;
  currency: string;
  serverName: string;
  phoneNumber: string;
}
